<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <users>
        </users> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import users from './todo-users'
export default {
    components: {
        users
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-users/base-users.vue